import { signIn } from './signIn';

export async function signInMvpd(): Promise<void> {
  try {
    await signIn({ isMvpd: true });
  } catch (ex) {
    console.error('[CentralizedLogin][signInMvpd] Error during MVPD sign-in:', ex);
  }
}
